import { render } from "./MetadataTable.vue?vue&type=template&id=9308f336&scoped=true"
import script from "./MetadataTable.vue?vue&type=script&lang=js"
export * from "./MetadataTable.vue?vue&type=script&lang=js"

import "./MetadataTable.vue?vue&type=style&index=0&id=9308f336&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9308f336"]])

export default __exports__